<template>
  <div class="addproject-step1">
    <ProjectStep1 hideControls />
    <ProjectStep2 hideControls class="mt-4"/>

    <div class="d-flex justify-end mt-8 mb-3 mr-8">
      <v-btn @click="back()" color="primary" outlined class="mr-3 px-13">Назад</v-btn>
      <v-btn @click="next()" color="primary" class="px-13" :loading="loading.calcProject">Подобрать кандидатов</v-btn>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProjectStep1 from './ProjectStep1';
import ProjectStep2 from './ProjectStep2';
/* eslint-disable */

export default {
  name: 'AIPage',
  components: {
    ProjectStep1, ProjectStep2
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      curProject: 'ai/hrprojects/curProject',
      loading: 'ai/hrprojects/loading',
    }),
  },
  methods: {
    ...mapActions({
      findCandidates: 'ai/hrprojects/findCandidates',
    }),
    back() {
      this.$emit('back')
    },
    async next() {
      await this.findCandidates(this.curProject);
      this.$emit('next')
    },
  }
};
</script>

<style lang="scss" scoped>

.addproject-step1 {
  width: 1200px;
  max-width: 100%;
}

.project-range {
  width: 300px; 
  max-width: 100%;

}
</style>

